import { inject, resource } from '@angular/core';
import type { IContentStore } from '@app/interface/content/content-store.interface';
import type { LookImage } from '@app/interface/image/look-image.interface';
import { isIrisUrl } from '@app/service/image/image-url';
import { IrisService } from '@app/service/iris/iris.service';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';

export const subjectImageResource = (
  imageSource: () =>
    | (Omit<Partial<LookImage>, 'viewURL' | 'bearerTokenURL'> & {
        viewURL?: LookImage['viewURL'] | null;
        bearerTokenURL?: LookImage['bearerTokenURL'] | null;
        attrs?: Record<string, string>;
      })
    | null
    | undefined
) => {
  const irisService = inject(IrisService);
  const contentStore = inject<IContentStore>(angularjs.ContentStore);

  return resource({
    params: () => {
      const image = imageSource();
      return {
        url: image?.viewURL,
        bearerTokenURL: image?.bearerTokenURL,
        attrs: image?.attrs
      };
    },
    loader: async ({ params }) => {
      if (!params.url) {
        return;
      }

      if (!isIrisUrl(params.url)) {
        return contentStore.resolveContentImagePath(params.url);
      }

      if (!params.bearerTokenURL) {
        return;
      }

      return irisService.load(params.url, params.bearerTokenURL, params.attrs);
    }
  });
};
